"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SevenKGateway = void 0;
const sdk_ts_1 = require("@7kprotocol/sdk-ts");
class SevenKGateway {
    constructor() { }
    async getQuote(tokenIn, tokenOut, amountIn, excludedPools) {
        const quoteResponse = await (0, sdk_ts_1.getQuote)({
            tokenIn,
            tokenOut,
            amountIn,
            excludedPools,
        });
        return quoteResponse;
    }
    async getTransactionBlock(tx, address, quoteResponse, slippage, coinIn) {
        const { coinOut } = await (0, sdk_ts_1.buildTx)({
            quoteResponse,
            accountAddress: address,
            slippage,
            commission: {
                partner: address, // Use the user's address as partner
                commissionBps: 0, // 0 basis points = no commission
            },
            extendTx: {
                tx,
                coinIn,
            },
        });
        return coinOut;
    }
}
exports.SevenKGateway = SevenKGateway;
//# sourceMappingURL=7k.js.map